<template>
  <div class="app-container">
    <PageTitle title="批量派单" ref="pageTitle" v-model="listQuery.city" @onChange="changeCity" />
    <div class="filter-container">
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入导游姓名"
        v-model="listQuery.guide_name"
      ></el-input>
      <el-select
        clearable
        v-model="listQuery.project_id"
        filterable
        collapse-tags
        placeholder="请选择项目名称"
        @change="handleProjectChange"
        style="width: 200px; margin-right: 10px; height: 32px"
      >
        <el-option
          v-for="item in project_options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="listQuery.use_date"
        type="date"
        placeholder="出发日期"
        value-format="yyyy-MM-dd"
        style="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
      ></el-date-picker>
      <TimeSelect
        v-model="listQuery.interval_time"
        customStyle="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
      />

      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.trip_type"
        placeholder="订单类型"
      >
        <el-option label="拼团" :value="1"></el-option>
        <el-option label="包团" :value="2"></el-option>
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <!-- 导游列表 -->
    <div v-loading="listLoading">
      <div class="guides-wrapper">
        <div class="guide-group" v-for="(guide, guideIndex) in guideList" :key="guideIndex">
          <div class="guide-header">
            导游 {{ guide.guide_name }} （服务时长{{ guide.service_duration }}分钟）{{
              guide.trip_type === 1 ? '拼团' : guide.trip_type === 2 ? '包团' : ''
            }}
          </div>
          <div class="order-list">
            <el-row v-if="guide.service_orders.length > 0">
              <el-col
                :span="12"
                v-for="(order, orderIndex) in guide.service_orders"
                :key="orderIndex"
              >
                <div
                  class="order-item"
                  @mouseenter="hoveredOrder = { guideIndex, orderIndex }"
                  @mouseleave="hoveredOrder = null"
                >
                  {{ order.contact.name }} {{ order.contact.mobile }} {{ order.user_num }}人

                  <i class="el-icon-success" v-if="order.is_assigned" style="color: #67c23a"></i>
                  <i
                    class="el-icon-circle-close"
                    v-if="
                      hoveredOrder &&
                      hoveredOrder.guideIndex === guideIndex &&
                      hoveredOrder.orderIndex === orderIndex
                    "
                    @click="handleCancelOrder(order)"
                  ></i>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="guide-footer">
            <el-button
              size="mini"
              type="primary"
              @click="handleAddOrder(guide, listQuery, project_name)"
              >添加游客</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="$refs.copyOrderInfo.handleCopyInfo(guide.guide_service_id)"
              >复制信息</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="handleAssignSubmit(guide.guide_service_id)"
              >一键派单</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <AddOrderList ref="tourist" @saveOrderData="saveOrderData" />
    <CopyOrderInfo ref="copyOrderInfo" />
  </div>
</template>

<script>
import { getList as getProjectList } from '@/api/projects'
import { getGuideList, assignSubmit } from '@/api/batchOrder'
import { cancel } from '@/api/assignRecord'
import { postGuidesAssign } from '@/api/service'
import PageTitle from '@/components/PageTitle'
import TimeSelect from '@/components/TimeSelect'
import AddOrderList from './components/AddOrderList'
import CopyOrderInfo from './components/CopyOrderInfo'
import Cookies from 'js-cookie'

// Cookie名称常量
const BATCH_ORDER_COOKIE_KEY = 'batch_order_query'

export default {
  name: 'BatchOrder',
  components: {
    PageTitle,
    TimeSelect,
    AddOrderList,
    CopyOrderInfo
  },
  data() {
    return {
      guideList: [],
      listLoading: false,
      project_options: [],
      project_name: '',
      listQuery: {
        city: '',
        project_id: '',
        trip_type: '',
        interval_time: '',
        use_date: '',
        guide_name: ''
        // project_id: '1',
        // trip_type: '1',
        // interval_time: '09:00',
        // use_date: '2025-08-03'
      },
      service_ids: [],
      hoveredOrder: null // 用于跟踪鼠标悬停的订单
    }
  },
  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })

    // 从 cookies 中读取保存的查询条件
    this.loadQueryFromCookies()
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    // 从 cookies 中加载查询条件
    loadQueryFromCookies() {
      const savedQuery = Cookies.get(BATCH_ORDER_COOKIE_KEY)
      if (savedQuery) {
        try {
          const parsedQuery = JSON.parse(savedQuery)
          // 合并保存的查询条件到当前查询条件
          this.listQuery = { ...this.listQuery, ...parsedQuery }
        } catch (error) {
          console.error('解析保存的查询条件失败', error)
        }
      }
    },

    // 将查询条件保存到 cookies
    saveQueryToCookies() {
      // 只保存有值的字段
      const queryToSave = {}
      Object.keys(this.listQuery).forEach((key) => {
        if (this.listQuery[key]) {
          queryToSave[key] = this.listQuery[key]
        }
      })

      // 保存到 cookies，有效期7天
      Cookies.set(BATCH_ORDER_COOKIE_KEY, JSON.stringify(queryToSave), { expires: 7 })
    },

    // 获取数据
    fetchData() {
      const query = { ...this.listQuery }
      if (!query.project_id) {
        this.$message.warning('请输入项目名称')
        return
      }
      if (!query.use_date) {
        this.$message.warning('请选择出发日期')
        return
      }
      if (!query.interval_time) {
        this.$message.warning('请选择场次')
        return
      }
      if (!query.trip_type) {
        this.$message.warning('请选择订单类型')
        return
      }
      this.listLoading = true

      // 保存查询条件到 cookies
      this.saveQueryToCookies()

      getGuideList(query)
        .then((res) => {
          this.guideList = res.data.guides || []
          this.listLoading = false
        })
        .catch((err) => {
          console.error('获取导游列表失败', err)
          this.listLoading = false
        })
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
    },
    handleProjectChange(e) {
      this.listQuery.project_id = e
      this.project_name = this.project_options.find((item) => item.id === e).name
      console.log(this.project_name)
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleAddOrder(guide, listQuery, project_name) {
      const nums = guide.service_orders.reduce((total, order) => total + (order.user_num || 0), 0)
      if (nums >= guide.user_limit) {
        this.$message.warning('服务人数已达上限')
        return
      }
      this.$refs.tourist.handleAddOrder(guide, listQuery, project_name)
    },
    _cancel(trip_service_id, msg) {
      cancel({ trip_service_id }).then(() => {
        this.$notify({
          title: '成功',
          message: '取消派单成功',
          type: 'success'
        })
        this.fetchData()
      })
    },

    /**
     * @description: 取消派单或移除游客
     * @param {*} guide 导游信息
     * @param {*} order 订单信息
     */
    handleCancelOrder(order) {
      const _this = this
      if (order.is_assigned) {
        // 已派单，需要取消派单
        this.$confirm('确认取消该游客的派单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this._cancel(order.trip_service_id, '取消派单成功')
        })
      } else {
        _this._cancel(order.trip_service_id, '移除游客成功')
      }
    },

    /**
     * @description: 一键派单
     * @param {*} guide 导游信息
     */
    handleAssign(guide) {
      // 检查是否超过人数上限
      // const totalAssigned = guide.service_orders.filter((order) => order.is_assigned).length
      const unassignedOrders = guide.service_orders.filter((order) => !order.is_assigned)

      if (unassignedOrders.length === 0) {
        this.$message.warning('没有可派单的游客')
        return
      }

      // 构造派单请求参数
      const orders = unassignedOrders.map((order) => order.order_id)
      postGuidesAssign({
        orders,
        guide_id: guide.guide_id,
        trip_type: this.listQuery.trip_type || 1
      }).then(() => {
        this.$notify({
          title: '成功',
          message: '派单成功',
          type: 'success'
        })
        this.fetchData()
      })
    },

    /**
     * @description:重置
     * @return {*}
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: this.$refs.pageTitle.city,
        project_id: '',
        trip_type: '',
        interval_time: '',
        use_date: '',
        guide_name: ''
      }
      this.fetchData()
    },
    saveOrderData() {
      this.fetchData()
    },
    /**
     * @description: 一键派单
     * @param {*} guide_service_id
     * @return {*}
     */
    handleAssignSubmit(guide_service_id) {
      assignSubmit({
        guide_service_id
      }).then(() => {
        this.$notify({
          title: '成功',
          message: '一键派单成功',
          type: 'success'
        })
        this.fetchData()
      })
    }
  }
}
</script>
<style scoped lang="less">
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}

.guides-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px; /* 抵消子元素的margin */
}

.guide-group {
  margin: 0 10px 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  width: calc(50% - 20px); /* 一行两列，减去左右margin */
  position: relative;
  padding-bottom: 50px;
}

.guide-header {
  background-color: #f5f7fa;
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
  text-align: center;
}

.order-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  width: 100%;
  .el-row {
    width: 100%;
    border: 1px solid #ebeef5;

    .el-col {
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
      &:nth-child(2n) {
        border-right: none;
      }
      &:nth-last-child(2),
      &:last-child {
        border-bottom: none;
      }
    }
  }
}

.order-item {
  position: relative;
  padding: 8px 12px;
  cursor: pointer;
}

.order-status {
  color: #67c23a;
  margin-left: 5px;
}

.order-cancel {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #f56c6c;
  cursor: pointer;
}

.add-order {
  margin: 5px;
  padding: 8px 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  color: #409eff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guide-footer {
  padding: 10px;
  width: 100%;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
